<div class="loader" *ngIf="isLoadingStatusModuleAssignments">
  <app-three-dots-blinking></app-three-dots-blinking>
</div>

<div class="page-wrapper" *ngIf="!isLoadingStatusModuleAssignments">
  <!--In Future version-->

  <!-- <div class="top-container">
  <div class="container">
    <span class="heading">Assignment Spotlight</span>
    <div class="cards-container">
      <div class="card">
        <div class="img-container">
          <img src="assets/icons/certificate-icon.svg" />
        </div>
        <div class="certification">
          <span>4 Certifications</span>
          <div class="details">
            Congrats! You’ve achieved expertise through hard work.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="img-container">
          <img src="assets/icons/assignments-icon.svg" />
        </div>
        <div class="certification">
          <span>10 Assignments</span>
          <div class="details">
            Nice job! You completed your assignments on time.
          </div>
        </div>
      </div>
      <div class="spacer"></div>
      <div class="warning-card">
        <img src="assets/icons/alert-circle-red.svg" />
        <div class="content">
          <span class="heading">Post Due Assignment</span>
          <div class="details">
            The Objection Handling Q3 2024 certification was due on May 25,
            2024.
          </div>
          <div class="finish">
            <span>Finish Now</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

  <div class="middle-container">
    <div class="assignment-heading-row">
      <qai-inner-wrap>
        <header data-testId="assignment-header">
          <h2 class="heading" data-testId="assignment-heading">
            {{ 'dashboard.ASSIGNMENT_LABEL' | transloco }}
          </h2>
        </header>
      </qai-inner-wrap>
    </div>
      
    <qai-inner-wrap>
      <div class="filter-row">
          <span class="total-label">
            {{ statusModuleAssignments.length }}
            {{ 'dashboard.TOTAL' | transloco }}
          </span>

          <qai-searchable-select
            [shape]="'rectangle'"
            [placeholder]="'dashboard.ASSIGNMENT_STATUS_LABEL' | transloco"
            [searchable]="false"
            [selectionPrefix]="'dashboard.ASSIGNMENT_STATUS_SELECTION_LABEL' | transloco"
            [options]="statusFilterOptions"
            [multiselect]="true"
            [value]="selectedStatuses"
            [disabled]="hasNoAssignments"
            (valueChange)="onStatusFilterChange($event)"
            [scopedOptionsSelectionMode]="visibleOptionsSelectionMode"
          >
          </qai-searchable-select>
          <qai-searchable-select [shape]="'rectangle'" [placeholder]="'dashboard.ASSIGNMENT_TYPE' | transloco"
            [options]="assignmentTypeFilterOptions" [multiselect]="true"
            [selectionPrefix]="'dashboard.ASSIGNMENT_TYPE_SELECTION_LABEL' | transloco" [value]="selectedTypes"
            [disabled]="hasNoAssignments" (valueChange)="onAssignmentTypeFilterChange($event)"
            [scopedOptionsSelectionMode]="scopedOptionsSelectionMode">
          </qai-searchable-select>

      </div> 
      <div class="tabs-container">
        <div class="tabs">
          <div
            class="all active"
            [ngClass]="{ active: selectedTab === 'all' }"
            (click)="showAll()"
          >
            <span> {{'dashboard.ALL' | transloco}} </span>
          </div>
          <div
            class="incomplete"
            [ngClass]="{ active: selectedTab === 'incomplete' }"
            (click)="showIncomplete()"
          >
            <span>{{'dashboard.IN_COMPLETE' | transloco}}</span>
            <span class="count">{{ incompleteModuleAssignments.length }}</span>
          </div>
          <div
            class="complete"
            [ngClass]="{ active: selectedTab === 'complete' }"
            (click)="showComplete()"
          >
            <span> {{'dashboard.COMPLETED' | transloco}} </span>
          </div>
          <!--In Future versions-->

          <!-- <mat-select
        id="teamSelect"
        hasBackdrop="true"
        [formControl]="sortControl"
      >
        <mat-option [value]="'due_date'">Sort By: Due Date</mat-option>
      </mat-select> -->
        </div>
      </div>

      <!-- Display All Assignments -->
      <ng-container *ngIf="selectedTab === 'all'">
        <app-learner-dashboard-tab-content
          [statusModuleAssignments]="statusModuleAssignments"
          [noAssignmentTitle]="noAssignmentTitle | transloco"
          [noAssignmentDetails]="noAssignmentDetails | transloco"
        ></app-learner-dashboard-tab-content>
      </ng-container>

      <!-- Display Incomplete Assignments -->
      <ng-container *ngIf="selectedTab === 'incomplete'">
        <app-learner-dashboard-tab-content
          [statusModuleAssignments]="incompleteModuleAssignments"
          [noAssignmentTitle]="'dashboard.IN_COMPLETE_ASSIGNMENT_TITLE' | transloco"
          [noAssignmentDetails]="
            'dashboard.IN_COMPLETE_ASSIGNMENT_DETAILS' | transloco
          "
        ></app-learner-dashboard-tab-content>
      </ng-container>

      <!-- Display Complete Assignments -->
      <ng-container *ngIf="selectedTab === 'complete'">
        <app-learner-dashboard-tab-content
          [statusModuleAssignments]="completeModuleAssignments"
          [noAssignmentTitle]="'dashboard.COMPLETED_ASSIGNMENT_TITLE' | transloco"
          [noAssignmentDetails]="
            'dashboard.COMPLETED_ASSIGNMENT_DETAILS' | transloco
          "
        ></app-learner-dashboard-tab-content>
      </ng-container>
    </qai-inner-wrap>
  </div>
</div>
<app-footer></app-footer>
